var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSurvey7Judgement = function SvgSurvey7Judgement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 124,
    viewBox: "0 0 101 124",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.872 67.0945C45.7968 68.4261 44.1427 69.2697 42.2984 69.2697C39.0482 69.2697 36.4099 66.6314 36.4099 63.3811C36.4099 60.1308 39.0482 57.4926 42.2984 57.4926C44.151 57.4926 45.8051 58.3527 46.8885 59.6925V46.0959L33.2092 46.1207C34.5987 45.0456 35.4836 43.3584 35.4836 41.4728C35.4836 38.2225 32.8453 35.5842 29.5951 35.5842C26.3448 35.5842 23.7065 38.2225 23.7065 41.4728C23.7065 43.2923 24.4674 44.9298 25.9561 46.1373H12.3264C12.3264 81.7167 46.8968 80.6663 46.8968 80.6663V67.1524",
    fill: "#B0CB1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9135 25.1469C47.9887 23.8154 49.6428 22.9718 51.4871 22.9718C54.7373 22.9718 57.3756 25.6101 57.3756 28.8604C57.3756 32.1106 54.7373 34.7489 51.4871 34.7489C49.6345 34.7489 47.9804 33.8888 46.897 32.549V46.1455L60.5763 46.1207C59.1868 47.1959 58.3019 48.8831 58.3019 50.7687C58.3019 54.019 60.9402 56.6573 64.1904 56.6573C67.4407 56.6573 70.079 54.019 70.079 50.7687C70.079 48.9492 69.3181 47.3117 67.8294 46.1042H81.4756C81.4756 10.5248 46.9052 11.5752 46.9052 11.5752V25.089",
    fill: "#A4B182"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.692 121.539C14.9484 120.464 15.213 119.397 15.4694 118.33C17.2475 111.011 19.2324 103.733 20.7377 96.3553C21.8211 91.0126 20.1753 86.1166 16.8919 81.7663C10.8793 73.8102 5.22234 66.3172 2.93143 56.3844C0.772847 47.0719 1.6247 37.0233 5.60278 28.3063C12.3845 13.4691 27.1307 4.20626 43.1174 2.65142C50.6683 1.91536 58.029 2.25444 65.2822 4.66941C74.5699 7.76255 82.8072 15.8428 86.7439 24.7335C88.5386 28.7777 89.5559 33.161 89.7626 37.5774C89.8619 39.6781 89.9942 42.151 89.4153 44.1938C88.8198 46.3193 88.1251 47.9403 89.0927 50.1733C89.2499 50.5289 89.4318 50.8763 89.6386 51.2154C91.5656 54.3747 93.6249 57.4513 95.6181 60.5692C96.4617 61.8842 97.3714 63.1579 98.0909 64.539C99.3315 66.9044 98.9014 68.0209 96.503 69.3028C94.8572 70.1877 92.4919 70.7253 91.8054 72.0982C91.3836 72.9418 92.0287 74.0996 92.3513 74.8688C92.8061 75.9687 93.2776 77.1266 93.17 78.3506C93.1204 78.9047 92.9137 79.4671 92.4836 79.8228C92.3347 79.9468 92.161 80.0461 92.0205 80.1701C91.8799 80.3024 91.7641 80.4761 91.7723 80.6746C91.8137 81.5099 92.7152 81.634 92.4836 82.6347C92.2851 83.5114 91.5987 84.2474 90.9453 84.8264C88.6048 86.894 90.2092 91.2029 89.9859 93.7502C89.8288 95.5366 89.1093 97.3561 87.6867 98.456C84.7673 100.714 80.1358 99.5477 76.8277 99.0267C71.5925 98.1996 64.7859 98.6876 64.1822 105.345C63.6777 110.878 64.3393 116.486 66.1009 121.754",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6504 9.72266V23.2365",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7265 44.293H15.0803",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6509 30.6964V44.293H35.9551",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6669 23.2944C50.7421 21.9628 52.3962 21.1193 54.2405 21.1193C57.4908 21.1193 60.129 23.7575 60.129 27.0078C60.129 30.2581 57.4908 32.8963 54.2405 32.8963C52.3879 32.8963 50.7338 32.0362 49.6504 30.6964",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7264 44.2931C27.2377 43.0856 26.4768 41.448 26.4768 39.6285C26.4768 36.3783 29.1151 33.74 32.3654 33.74C35.6156 33.74 38.2539 36.3783 38.2539 39.6285C38.2539 41.5225 37.3524 43.2179 35.963 44.2931",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2136 44.2599H70.6997",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2477 44.2599H49.6511",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6418 44.2764C71.9733 45.3516 72.8169 47.0057 72.8169 48.85C72.8169 52.1003 70.1786 54.7385 66.9283 54.7385C63.6781 54.7385 61.0398 52.1003 61.0398 48.85C61.0398 46.9974 61.8999 45.3433 63.2397 44.2599",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6511 78.822V65.3081",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6511 57.8565V44.2599",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6262 65.2503C48.551 66.5818 46.8969 67.4254 45.0526 67.4254C41.8023 67.4254 39.1641 64.7871 39.1641 61.5369C39.1641 58.2866 41.8023 55.6483 45.0526 55.6483C46.9052 55.6483 48.5593 56.5084 49.6427 57.8483",
    stroke: "#32332B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurvey7Judgement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/survey_7_judgement.1f97c235.svg";
export { ForwardRef as ReactComponent };